// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/bg_desktop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/bg_mobile_j.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner_wrapper__VRvwB {
  position: relative;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ {
  align-items: center;
  display: flex;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz {
  padding: 0 20px;
  margin-top: 300px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: end;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_banner_pic__NtVlN {
  display: block;
  max-width: 60%;
  height: auto;
  object-fit: contain;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_banner_pic_mob__OtHvv {
  display: none;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 {
  max-width: 820px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-left: 100px;
  gap: 20px;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_title__C\\+aJj {
  font-family: "DrukWideCyr_bold";
  font-weight: 700;
  font-size: 52px;
  line-height: 116%;
  text-transform: uppercase;
  text-align: center;
  color: #ffffff;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_desc__CuMGo {
  font-weight: 600;
  font-size: 20px;
  line-height: 129%;
  letter-spacing: -0.02em;
  text-align: center;
  color: #ececec;
  font-family: "SFPro_semibold";
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_subtitle__WbB-\\+ {
  color: #ffffff;
  font-weight: 500;
  font-size: 24px;
  font-family: "HelveticaNeue";
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_btn__n\\+A08 {
  border-radius: 8px;
  width: 392px;
  height: 64px;
  background: #fd4c0a;
  font-family: "SFPro_semibold";
  font-weight: 500;
  font-size: 20px;
  line-height: 130%;
  text-transform: capitalize;
  color: #ffffff;
  cursor: pointer;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_rules__dqrB3 {
  font-family: "SFPro_regular";
  font-weight: 400;
  font-size: 16px;
  line-height: 125%;
  letter-spacing: -0.02em;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-align: center;
  color: #c2bdb2;
  cursor: pointer;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g {
  color: #ffffff;
  z-index: 2;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_title__C\\+aJj {
  font-size: 64px;
  font-weight: 700;
  font-style: normal;
  margin-bottom: 20px;
  font-weight: 700;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_subtitle__WbB-\\+ {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  line-height: 120%;
  margin-bottom: 24px;
  width: 45%;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_btn__n\\+A08 {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  border-radius: 8px;
  cursor: pointer;
  padding: 10px 22px;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_reg__q7K3w {
  background-color: #ead40c;
  color: #1b1e23;
}
.Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_platforms__B4Amx {
  align-items: center;
  display: flex;
  gap: 32px;
  margin-top: 40px;
}
.Banner_wrapper__VRvwB .Banner_bannerDesk__lSpTL {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: right;
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.Banner_wrapper__VRvwB .Banner_banner__C9vZp {
  display: none;
}

@media (max-width: 1000px) {
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz {
    margin-bottom: 20px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 {
    margin-left: 0px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_banner_pic__NtVlN {
    width: 60%;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_title__C\\+aJj {
    width: 50%;
  }
}
@media (max-width: 850px) {
  .Banner_wrapper__VRvwB {
    display: block;
    padding-top: 100px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ {
    height: unset;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_title__C\\+aJj {
    font-size: 48px;
    font-weight: 700;
    font-style: normal;
    width: 100%;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_subtitle__WbB-\\+ {
    width: 90%;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_platforms__B4Amx img {
    width: 180px;
  }
  .Banner_wrapper__VRvwB .Banner_bannerDesk__lSpTL {
    display: none;
  }
  .Banner_wrapper__VRvwB .Banner_banner__C9vZp {
    display: block;
  }
  .Banner_wrapper__VRvwB .Banner_banner__C9vZp img {
    width: 100%;
  }
}
@media (max-width: 500px) {
  .Banner_wrapper__VRvwB {
    height: auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-size: contain;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz {
    margin-left: 0px;
    margin-top: 0px;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;
    width: 100%;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_banner_pic__NtVlN {
    display: none;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_banner_pic_mob__OtHvv {
    display: block;
    margin-top: 30px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 {
    margin-top: 120px;
    width: 100%;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_btn__n\\+A08 {
    place-self: center;
    width: 319px;
    height: 49px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_subtitle__WbB-\\+ {
    font-size: 20px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_title__C\\+aJj {
    font-size: 28px;
    text-align: center;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_desc__CuMGo {
    font-weight: 600;
    font-size: 11px;
    line-height: 129%;
    letter-spacing: -0.02em;
    text-align: center;
    color: #ececec;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_section__h7eSz .Banner_group__opTD8 .Banner_btn__n\\+A08 {
    font-size: 18px;
    margin-top: 0px;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g {
    z-index: 0;
  }
  .Banner_wrapper__VRvwB .Banner_info__avNnJ .Banner_container__GCK-g .Banner_platforms__B4Amx img {
    width: 150px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Banner/Banner.module.scss","webpack://./src/assets/styles/_mixins.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;AADF;AAGE;ECHA,mBAAA;EACA,aAAA;ADGF;AAEI;EACE,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AAAN;AAEM;EACE,cAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AAAR;AAEM;EACE,aAAA;AAAR;AAEM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;AAAR;AAEQ;EACE,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;AAAV;AAEQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;AAAV;AAEQ;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,4BAAA;AAAV;AAGQ;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,eAAA;AADV;AAGQ;EACE,4BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;EACA,8BAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AADV;AAMI;EACE,cAAA;EACA,UAAA;AAJN;AAMM;EE9FJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF8FM,mBAAA;EACA,gBAAA;AAFR;AAKM;EE1DJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF0DM,iBAAA;EACA,mBAAA;EACA,UAAA;AADR;AAIM;EE3DJ,eAAA;EACA,gBAAA;EACA,kBAAA;EF2DM,kBAAA;EACA,eAAA;EACA,kBAAA;AAAR;AAGM;EACE,yBAAA;EACA,cAAA;AADR;AAIM;ECnHJ,mBAAA;EACA,aAAA;EDoHM,SAAA;EACA,gBAAA;AADR;AAME;EACE,yDAAA;EACA,oBAAA;EACA,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;AAJJ;AAOE;EACE,aAAA;AALJ;;AASA;EAGM;IAIE,mBAAA;EAXN;EAQM;IACE,gBAAA;EANR;EASM;IACE,UAAA;EAPR;EAYM;IACE,UAAA;EAVR;AACF;AAgBA;EACE;IACE,cAAA;IACA,kBAAA;EAdF;EAgBE;IACE,aAAA;EAdJ;EAiBM;IEzKN,eAAA;IACA,gBAAA;IACA,kBAAA;IFyKQ,WAAA;EAbR;EAgBM;IACE,UAAA;EAdR;EAkBQ;IACE,YAAA;EAhBV;EAsBE;IACE,aAAA;EApBJ;EAuBE;IACE,cAAA;EArBJ;EAuBI;IACE,WAAA;EArBN;AACF;AA0BA;EACE;IACE,YAAA;IACA,yDAAA;IACA,4BAAA;IACA,wBAAA;EAxBF;EA0BI;IACE,gBAAA;IACA,eAAA;IACA,eAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,kBAAA;IACA,WAAA;EAxBN;EAyBM;IACE,aAAA;EAvBR;EAyBM;IACE,cAAA;IACA,gBAAA;EAvBR;EA0BM;IACE,iBAAA;IACA,WAAA;EAxBR;EAyBQ;IACE,kBAAA;IACA,YAAA;IACA,YAAA;EAvBV;EAyBQ;IACE,eAAA;EAvBV;EA0BQ;IACE,eAAA;IACA,kBAAA;EAxBV;EA0BQ;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,uBAAA;IACA,kBAAA;IACA,cAAA;EAxBV;EA0BQ;IACE,eAAA;IACA,eAAA;EAxBV;EA6BI;IACE,UAAA;EA3BN;EA8BQ;IACE,YAAA;EA5BV;AACF","sourcesContent":["@import \"../../assets/styles/global.scss\";\n\n.wrapper {\n  position: relative;\n  background-image: url(\"../../assets/images/bg_desktop.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  \n  .info {\n    @include df-aic;\n\n    .section {\n      padding: 0 20px;\n      margin-top: 300px;\n      display: flex;\n      align-items: center;\n      width: 100%;\n      justify-content: end;\n\n      .banner_pic {\n        display: block;\n        max-width: 60%;\n        height: auto;\n        object-fit: contain;\n      }\n      .banner_pic_mob {\n        display: none;\n      }\n      .group {\n        max-width: 820px;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 10px;\n        margin-left: 100px;\n        gap: 20px;\n\n        .title {\n          font-family: \"DrukWideCyr_bold\";\n          font-weight: 700;\n          font-size: 52px;\n          line-height: 116%;\n          text-transform: uppercase;\n          text-align: center;\n          color: #ffffff;\n        }\n        .desc {\n          font-weight: 600;\n          font-size: 20px;\n          line-height: 129%;\n          letter-spacing: -0.02em;\n          text-align: center;\n          color: #ececec;\n          font-family: \"SFPro_semibold\";\n        }\n        .subtitle {\n          color: #ffffff;\n          font-weight: 500;\n          font-size: 24px;\n          font-family: \"HelveticaNeue\";\n        }\n\n        .btn {\n          border-radius: 8px;\n          width: 392px;\n          height: 64px;\n          background: #fd4c0a;\n          font-family: \"SFPro_semibold\";\n          font-weight: 500;\n          font-size: 20px;\n          line-height: 130%;\n          text-transform: capitalize;\n          color: #ffffff;\n          cursor: pointer;\n        }\n        .rules {\n          font-family: \"SFPro_regular\";\n          font-weight: 400;\n          font-size: 16px;\n          line-height: 125%;\n          letter-spacing: -0.02em;\n          text-decoration: underline;\n          text-decoration-skip-ink: none;\n          text-align: center;\n          color: #c2bdb2;\n          cursor: pointer;\n        }\n      }\n    }\n\n    .container {\n      color: #ffffff;\n      z-index: 2;\n\n      .title {\n        @include h1;\n        margin-bottom: 20px;\n        font-weight: 700;\n      }\n\n      .subtitle {\n        @include subtitle5;\n        line-height: 120%;\n        margin-bottom: 24px;\n        width: 45%;\n      }\n\n      .btn {\n        @include subtitle6m;\n        border-radius: 8px;\n        cursor: pointer;\n        padding: 10px 22px;\n      }\n\n      .reg {\n        background-color: #ead40c;\n        color: #1b1e23;\n      }\n\n      .platforms {\n        @include df-aic;\n        gap: 32px;\n        margin-top: 40px;\n      }\n    }\n  }\n\n  .bannerDesk {\n    background-image: url(\"../../assets/images/banner.png\");\n    background-size: 50%;\n    background-repeat: no-repeat;\n    background-position: right;\n    bottom: 0;\n    left: 0;\n    position: absolute;\n    right: 0;\n    top: 0;\n  }\n\n  .banner {\n    display: none;\n  }\n}\n\n@media (max-width: 1000px) {\n  .wrapper {\n    .info {\n      .section {\n        .group {\n          margin-left: 0px;\n        }\n        margin-bottom: 20px;\n        .banner_pic {\n          width: 60%;\n        }\n      }\n\n      .container {\n        .title {\n          width: 50%;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 850px) {\n  .wrapper {\n    display: block;\n    padding-top: 100px;\n\n    .info {\n      height: unset;\n\n      .container {\n        .title {\n          @include h2;\n          width: 100%;\n        }\n\n        .subtitle {\n          width: 90%;\n        }\n\n        .platforms {\n          img {\n            width: 180px;\n          }\n        }\n      }\n    }\n\n    .bannerDesk {\n      display: none;\n    }\n\n    .banner {\n      display: block;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .wrapper {\n    height: auto;\n    background-image: url(\"../../assets/images/bg_mobile_j.png\");\n    background-repeat: no-repeat;\n    background-size: contain;\n    .info {\n      .section {\n        margin-left: 0px;\n        margin-top: 0px;\n        padding: 0 10px;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        margin-bottom: 0px;\n        width: 100%;\n        .banner_pic {\n          display: none;\n        }\n        .banner_pic_mob {\n          display: block;\n          margin-top: 30px;\n        }\n\n        .group {\n          margin-top: 120px;\n          width: 100%;\n          .btn {\n            place-self: center;\n            width: 319px;\n            height: 49px;\n          }\n          .subtitle {\n            font-size: 20px;\n          }\n\n          .title {\n            font-size: 28px;\n            text-align: center;\n          }\n          .desc {\n            font-weight: 600;\n            font-size: 11px;\n            line-height: 129%;\n            letter-spacing: -0.02em;\n            text-align: center;\n            color: #ececec;\n          }\n          .btn {\n            font-size: 18px;\n            margin-top: 0px;\n          }\n        }\n      }\n\n      .container {\n        z-index: 0;\n\n        .platforms {\n          img {\n            width: 150px;\n          }\n        }\n      }\n    }\n  }\n}\n","@mixin df {\n  display: flex;\n}\n\n@mixin df-aic {\n  align-items: center;\n  display: flex;\n}\n\n@mixin df-aic-g8 {\n  align-items: center;\n  display: flex;\n  gap: 8px;\n}\n\n@mixin df-aic-jcc {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n}\n\n@mixin df-aic-jcsb {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n@mixin hoverYellow {\n  transition: all .2s linear;\n\n  &:hover {\n    color: $c-yellow;\n  }\n}\n\n@mixin borderYellow {\n  border: 1px solid $c-yellow;;\n  transition: all .2s linear;\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Banner_wrapper__VRvwB`,
	"info": `Banner_info__avNnJ`,
	"section": `Banner_section__h7eSz`,
	"banner_pic": `Banner_banner_pic__NtVlN`,
	"banner_pic_mob": `Banner_banner_pic_mob__OtHvv`,
	"group": `Banner_group__opTD8`,
	"title": `Banner_title__C+aJj`,
	"desc": `Banner_desc__CuMGo`,
	"subtitle": `Banner_subtitle__WbB-+`,
	"btn": `Banner_btn__n+A08`,
	"rules": `Banner_rules__dqrB3`,
	"container": `Banner_container__GCK-g`,
	"reg": `Banner_reg__q7K3w`,
	"platforms": `Banner_platforms__B4Amx`,
	"bannerDesk": `Banner_bannerDesk__lSpTL`,
	"banner": `Banner_banner__C9vZp`
};
export default ___CSS_LOADER_EXPORT___;
